module.exports = __webpack_public_path__ + "img/1498501179.59afc29d.jpg";